export enum TipoPontoDeChegadaEnum {
  CD = 'CD',
  MO = 'MO',
  UE = 'UE'
}

export interface TipoPontoDeChegada {
  codigo: TipoPontoDeChegadaEnum;
  descricao: string;
}

export const TipoPontoDeChegada: TipoPontoDeChegada[] = [
  {
    codigo: TipoPontoDeChegadaEnum.CD,
    descricao: 'Centro de Distribuição',

  },
  {
    codigo: TipoPontoDeChegadaEnum.MO,
    descricao: 'Residência do Motorista',
  },
  {
    codigo: TipoPontoDeChegadaEnum.UE,
    descricao: 'Última Entrega',
  }
];
